<div class="dialog">
  <h4 mat-dialog-title>{{ data.title }}</h4>
  <form #form="ngForm">
    <mat-form-field>
      <mat-label>{{ 'common_field_label' | translate }}</mat-label>
      <input matInput [(ngModel)]="data.displayName" cdkFocusInitial name="displayName" maxlength="100" required />
      <mat-hint align="end">{{ data.displayName?.length || 0 }} / 100</mat-hint>
      <mat-error *ngIf="!data.displayName" [innerHTML]="'common_error_label_required' | translate"></mat-error>
    </mat-form-field>
    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button (click)="onSubmit()" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
